module.exports = __webpack_public_path__ + "static/content-106cf968514c03097eca525abbe7941b.jpg";